// extracted by mini-css-extract-plugin
module.exports = {"btnText":"OrderDetailsPage_btnText__37Xjq","content":"OrderDetailsPage_content__3kLWi"};